import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { register } from 'swiper/element/bundle';

register();

@Component({
  selector: 'app-attachment-modal',
  templateUrl: './attachment-modal.component.html',
  styleUrl: './attachment-modal.component.scss',
})
export class AttachmentModalComponent {
  @Input() images: string[] = [];
  @Input() startIndex: number = 0;

  constructor(public activeModal: NgbActiveModal) {}

}
